import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_UPLOAD_ALL_REQUESTED_FILES,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_UPLOAD_BUSINESS_LICENSE,
	STR_UPLOAD_NIDA_ID_COPY_BACK,
	STR_UPLOAD_NIDA_ID_COPY_FRONT,
	STR_UPLOAD_TIN_CERTIFICATE,
	STR_VERIFY_YOUR_PROFILE,
	STR_YOU_HAVE_SUBMITTED_AGENT_VERIFICATION_REQUEST,
	STR_YOU_WERE_VERIFIED
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate, MdVerified } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";

export default function ProfileVerification(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getCurrentUserData();
		setReady(true);
	}

	async function submit() {
		const tinCertificate = document.getElementById('_tinCertificate').files[0];
		const nidaIdCopyFront = document.getElementById('_nidaIdCopyFront').files[0];
		const nidaIdCopyBack = document.getElementById('_nidaIdCopyBack').files[0];
		const businessLicense = document.getElementById('_businessLicense').files[0];

		if(tinCertificate && nidaIdCopyFront && nidaIdCopyBack && businessLicense) {
			setLoading(true);
			await callApi(
				'submit-agent-verification-request',
				{
					tinCertificate,
					nidaIdCopyFront,
					nidaIdCopyBack,
					businessLicense,
				}
			).then(async (response) => {
				if(response.status === 1) {
					setOpSuccessful(true);
					await appContext.getCurrentUserData()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_PLEASE_UPLOAD_ALL_REQUESTED_FILES[appContext.language]);
		}

	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
	
						<div className="row">
	
							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_VERIFY_YOUR_PROFILE[appContext.language]}
								</h6>
							</div>

							{
								(appContext.currentUserData.agentVerificationStatus === 'unverified' || appContext.currentUserData.agentVerificationStatus === 'rejected') ?
								(opSuccessful) ?
								<div 
									className="col-md-12"
								>
									<OpSuccessWidget/>
								</div>
								:
								<div 
									className="col-md-12"
								>
									<div className="mt-4 mb-4">
										<label className="form-label">{STR_UPLOAD_TIN_CERTIFICATE[appContext.language]}</label>
										<input
											className="form-control"
											type="file"
											id="_tinCertificate"
										/>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_UPLOAD_NIDA_ID_COPY_FRONT[appContext.language]}</label>
										<input
											className="form-control"
											type="file"
											id="_nidaIdCopyFront"
										/>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_UPLOAD_NIDA_ID_COPY_BACK[appContext.language]}</label>
										<input
											className="form-control"
											type="file"
											id="_nidaIdCopyBack"
										/>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_UPLOAD_BUSINESS_LICENSE[appContext.language]}</label>
										<input
											className="form-control"
											type="file"
											id="_businessLicense"
										/>
									</div>

									<div className="mt-4 mb-4">
										<button
											className="btn btn-block btn-primary btn-padded btn-rounded"
											onClick={submit}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>

								</div>
								:""
							}

							{
								(appContext.currentUserData.agentVerificationStatus === 'requested') ?
								<div 
									className="col-md-12"
								>
									<h1
										className="text-center font-light"
										style={{
											fontSize: "24px",
											padding: "30px"
										}}
									>
										<MdCheckCircle className="text-secondary" size={48}/>
										<br/>
										{STR_YOU_HAVE_SUBMITTED_AGENT_VERIFICATION_REQUEST[appContext.language]}
									</h1>
								</div>
								:""
							}

							{
								(appContext.currentUserData.agentVerificationStatus === 'verified') ?
								<div 
									className="col-md-12"
								>
									<h1
										className="text-center font-light"
										style={{
											fontSize: "24px",
											padding: "30px"
										}}
									>
										<MdVerified className="text-secondary" size={48}/>
										<br/>
										{STR_YOU_WERE_VERIFIED[appContext.language]}
									</h1>
								</div>
								:""
							}
	
						</div>
	
						
	
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}